define('home/views/RelatedDiscussionsModuleView',[
    'backbone-marionette',

    'home/views/RelatedDiscussionView',
    'home/views/ProfileModuleEmptyView',

    'home/templates/relatedDiscussionsModule',
], function (
    Marionette,

    RelatedDiscussionView,
    ProfileModuleEmptyView,

    relatedDiscussionsModuleTemplate
) {
    'use strict';
    /**
     * A view that shows a recommended discussion module with a list of discussions.
     * The model is assumed to be a `Backbone.Collection` object.
     */
    var RelatedDiscussionsModuleView = Marionette.CompositeView.extend({
        template: relatedDiscussionsModuleTemplate,
        itemView: RelatedDiscussionView,
        itemViewContainer: '[data-role=discussions]',
        emptyView: ProfileModuleEmptyView,
    });

    return RelatedDiscussionsModuleView;
});

